import { viewport } from './viewport';

function init() {
  document.querySelectorAll('.content').forEach((content) => {
    [...content.children].forEach((el, i) => {
      el.classList.add('animation');
      el.offsetWidth;

      viewport.observe(el, () => {
        el.style.transitionDelay = `${i * 100}ms`;
        el.classList.add('animated');
      });
    });
  });

  document.querySelectorAll('.hero__shape').forEach((shape) => {
    [...shape.children].forEach((el, i) => {
      el.classList.add('animation');
      el.offsetWidth;

      viewport.observe(el, () => {
        el.style.transitionDelay = `${i * 100}ms`;
        el.classList.add('animated');
      });
    });
  });
}

init();

window.addEventListener('init', () => init());